import React from 'react';
import { Link } from 'react-router-dom';
import AppStoreBadges, { isCustomDomain } from './AppStoreBadges';

export default function Footer({ contactInfo }) {
  if (!contactInfo) return null;
  const showMobile = isCustomDomain();

  return (
    <footer className={`${showMobile ? 'block' : 'hidden lg:block'} bg-white w-full`}>
      <div className="px-5 lg:px-12 pt-3 lg:pt-4 pb-8 lg:pb-12 w-full">
        <div className="flex flex-col lg:flex-row justify-between items-start gap-6 lg:gap-10">
        {/* Company Info Section */}
        <div className="text-left text-xs text-black space-y-1">
          {contactInfo.footer_copyright_text && (
            <p className="text-sm font-bold text-black">{contactInfo.footer_copyright_text}</p>
          )}
          {contactInfo.address_line_1 && (
            <p>{contactInfo.address_line_1}, {contactInfo.address_line_2}{contactInfo.address_line_3 ? `, ${contactInfo.address_line_3}` : ''}, {contactInfo.postcode}</p>
          )}
          {contactInfo.company_registration_number && (
            <p>Company Registration Number: {contactInfo.company_registration_number}</p>
          )}
          {contactInfo.vat_registration_number && (
            <p>Vat Registration Number: {contactInfo.vat_registration_number}</p>
          )}
          {contactInfo.phone && (
            <p>Phone Number: {contactInfo.phone}</p>
          )}
          {contactInfo.email && (
            <p>Email: {contactInfo.email}</p>
          )}
        </div>

          <AppStoreBadges
            appStoreUrl={contactInfo.app_store_url}
            playStoreUrl={contactInfo.google_play_url}
            className="lg:text-right"
          />
        </div>

        {/* Links + social icons row */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mt-8 pt-6 border-t border-gray-200">
          <div className="flex gap-x-6 gap-y-3 flex-wrap">
            <Link to="/Cookies" className="text-xs font-bold text-black hover:opacity-70 transition-opacity">
              Cookies
            </Link>
            <Link to="/GDPR" className="text-xs font-bold text-black hover:opacity-70 transition-opacity">
              GDPR
            </Link>
            <Link to="/HowToRegister" className="text-xs font-bold text-black hover:opacity-70 transition-opacity">
              How to Register
            </Link>
            <Link to="/PrivacyPolicy" className="text-xs font-bold text-black hover:opacity-70 transition-opacity">
              Privacy Policy
            </Link>
            <Link to="/Security" className="text-xs font-bold text-black hover:opacity-70 transition-opacity">
              Security
            </Link>
            <Link to="/TermsAndConditions" className="text-xs font-bold text-black hover:opacity-70 transition-opacity">
              Terms & Conditions
            </Link>
          </div>

            {contactInfo && (contactInfo.facebook || contactInfo.instagram || contactInfo.tiktok) && (
              <div className="flex items-center gap-4 justify-end">
                {contactInfo.facebook && (
                  <a href={contactInfo.facebook} target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook" className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-navy text-white hover:opacity-90 transition-opacity">
                    <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M13.5 22v-8h2.7l.4-3.1h-3.1V8.9c0-.9.25-1.5 1.55-1.5h1.65V4.6c-.3-.04-1.3-.13-2.45-.13-2.43 0-4.1 1.48-4.1 4.2v2.23H7.4V14h2.75v8h3.35z" /></svg>
                  </a>
                )}
                {contactInfo.instagram && (
                  <a href={contactInfo.instagram} target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram" className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-navy text-white hover:opacity-90 transition-opacity">
                    <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M12 2.2c3.2 0 3.58.01 4.85.07 1.17.05 1.96.24 2.65.51.71.28 1.31.65 1.9 1.24.59.59.96 1.19 1.24 1.9.27.69.46 1.48.51 2.65.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.24 1.96-.51 2.65a5.27 5.27 0 01-1.24 1.9c-.59.59-1.19.96-1.9 1.24-.69.27-1.48.46-2.65.51-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.96-.24-2.65-.51a5.27 5.27 0 01-1.9-1.24 5.27 5.27 0 01-1.24-1.9c-.27-.69-.46-1.48-.51-2.65C2.21 15.58 2.2 15.2 2.2 12s.01-3.58.07-4.85c.05-1.17.24-1.96.51-2.65.28-.71.65-1.31 1.24-1.9.59-.59 1.19-.96 1.9-1.24.69-.27 1.48-.46 2.65-.51C8.42 2.21 8.8 2.2 12 2.2zm0 4.9a4.9 4.9 0 100 9.8 4.9 4.9 0 000-9.8zm0 8.08a3.18 3.18 0 110-6.36 3.18 3.18 0 010 6.36zm6.24-8.28a1.14 1.14 0 11-2.28 0 1.14 1.14 0 012.28 0z" /></svg>
                  </a>
                )}
                {contactInfo.tiktok && (
                  <a href={contactInfo.tiktok} target="_blank" rel="noopener noreferrer" aria-label="Follow us on TikTok" className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-navy text-white hover:opacity-90 transition-opacity">
                    <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M16.6 5.82A4.28 4.28 0 0115.54 3h-3.09v12.4a2.59 2.59 0 11-1.86-2.49v-3.1a5.68 5.68 0 105.68 5.68V9.4a7.3 7.3 0 004.28 1.38V7.7a4.29 4.29 0 01-3.95-1.88z" /></svg>
                  </a>
                )}
              </div>
            )}
        </div>
      </div>
    </footer>
  );
}